import { Pipe, PipeTransform } from '@angular/core';
import { HelpService } from './help.service';

@Pipe({
  name: 'helpLink',
  standalone: true
})
export class HelpLinkPipe implements PipeTransform {
  constructor(private service: HelpService) {}

  /**
   * Pipe for convert link to correct help link
   * @param {String} pageAddress - for example '/whats-new/release-history'
   * @return {String}
   */
  transform(pageAddress: string): string {
    return this.service.getHelpLink(pageAddress);
  }
}
